// src/App.js
import React from 'react';
import './App.css';
import HomePage from './Views/homepage';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import ScrollToTop from './Components/ScrollToTop';
import Evosite from './Pages/Evosite';
import Dstillery from './Pages/Dstillery';
import Varietal from './Pages/Varietal';
import Contrast from './Pages/Contrast';
import Photo from './NavPages/Photo';
import Showreel from './NavPages/Showreel';
import Videography from './NavPages/Videography';
import About from './NavPages/About';
import Index from './NavPages/Index';
import Pharmaceutical from './Pages/Pharmaceutical';
import Login from './NavPages/Login';
import CoffeeCv from './NavPages/CoffeeCv';
import RunnerCv from './NavPages/RunnerCv';
import ColourCv from './NavPages/ColourCv';
import VideographyCv from './NavPages/VideographyCv';
import CoverLetter from './NavPages/CoverLetter';
import PortfolioPdf from './NavPages/PortfolioPdf';
import Travelperk from './Pages/Travelperk';
import Keymotion from './Pages/Keymotion';
import AdareCollection from './Pages/AdareCollection';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <div className='App'>
      <Router>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            <Route path='/' element={<HomePage />} />
            {/* Hidden projects: any inbound links (e.g. from the CV on the
                Info page) land on the homepage */}
            <Route path='/astrazeneca' element={<Navigate to='/' replace />} />
            <Route path='/ubitricity' element={<Navigate to='/' replace />} />
            <Route path='/evoagency' element={<Evosite />} />
            <Route path='/dstillery' element={<Dstillery />} />
            <Route path='/varietal' element={<Varietal />} />
            <Route path='/contrastsecurity' element={<Contrast />} />
            <Route path='/photo' element={<Photo />} />
            <Route path='/index' element={<Index />} />
            <Route path='/showreel' element={<Showreel />} />
            <Route path='/videography' element={<Videography />} />
            <Route path='/info' element={<About />} />
            <Route path='/about' element={<Navigate to='/info' replace />} />
            <Route path='/login' element={<Login />} />
            <Route path='/travelperk' element={<Travelperk />} />
            <Route path='/keymotion' element={<Keymotion />} />
            <Route path='/adarecollection' element={<AdareCollection />} />
            <Route path='/healthcare' element={<Pharmaceutical />} />
            {/* Unlinked from the rest of the site; shared by direct link only */}
            <Route path='/coffeecv' element={<CoffeeCv />} />
            <Route path='/runnercv' element={<RunnerCv />} />
            <Route path='/colourcv' element={<ColourCv />} />
            <Route path='/videographycv' element={<VideographyCv />} />
            <Route path='/coverletter' element={<CoverLetter />} />
            <Route path='/portfolio-pdf' element={<PortfolioPdf />} />
            {/* 404 fallback */}
            <Route
              path='*'
              element={
                <div style={{padding:'2rem',textAlign:'center'}}>
                  <h1>404 — Page Not Found</h1>
                  <p>The page you're looking for doesn't exist.</p>
                </div>
              }
            />
          </Routes>
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
